export default "__VITE_ASSET__BgvTV0rn__"